exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Overview-module__wrapper___3N-zj{display:grid;grid-template-columns:repeat(2,250px);gap:1.5em}@media screen and (min-width:1000px){.Overview-module__wrapper___3N-zj{grid-template-columns:repeat(3,250px)}}.Overview-module__text-wrapper___1799j{background-color:#fff;padding:.25em;border-radius:4px}", ""]);

// exports
exports.locals = {
	"wrapper": "Overview-module__wrapper___3N-zj",
	"text-wrapper": "Overview-module__text-wrapper___1799j"
};